module.exports = __webpack_public_path__ + "img/PRprinting1.af21fe8e.png";